export enum ErrorCodes {
    E_AUTH_INVALID_CODE_AUTHORIZATION = 'Código de Autorização é invalido.',
    E_AUTH_INVALID_STATE_AUTHORIZATION = 'Código esperado é invalido.',
    E_AUTH_INVALID_TYPE_USER = 'Tipo de usuário é inválido.',
    E_AUTH_USER_NOT_FOUND = 'Usuário não encontrado. Por favor, entre em contato com o suporte.',
    E_AUTH_GET_TOKEN_DATA = "Não foi possível obter dados da autenticação.",
    E_AUTH_SET_DATA_TOKEN = "Não foi possível atualizar informações da autenticação.",
    E_AUTH_GENERIC = 'Não foi possível efetuar a autenticação.',
    E_GENERIC = 'Não foi possível processar a requisição.'
}
